var _ = require('underscore');
var $ = require('jquery');
var Dialog = require('Dialog');
var Entities = require('Entities');
var ExportNode = require('ExportNode');
var Labels = EY.Consultation.Labels;
var Marionette = require('marionette');
var RecordType = EY.Consultation.Lookups.RecordType;
var Resources = EY.Consultation.Resources;
var Geographies = _.indexBy(Resources.Geography, 'id');
var User = EY.Consultation.CurrentUser;

var searchTopicCollection = Backbone.Collection.extend({
    comparator: function (item) {
        return [item.get("area"), item.get("region"),item.get("countryText"), item.get("recordType"), item.get("typeText"), item.get("subTypeText"), item.get("subjectText")];
    }
});

var fields = function () {
    return [
        { value: 'area', label: Labels.Area },
        { value: 'region', label: Labels.Region },
        { value: 'countryText', label: Labels.Country },
        { value: 'recordType', label: Labels.RecordType },
        { value: 'typeText', label: Labels.Topic },
        { value: 'subTypeText', label: Labels.Subtopic1 },
        { value: 'subjectText', label: Labels.Subject }];
};

var columns = function () {
    return [
        { name: 'area', label: Labels.Area, editable: false, cell: 'string', columnWidth: 'S' },
        { name: 'region', label: Labels.Region, editable: false, cell: 'string', columnWidth: 'S' },
        { name: 'countryText', label: Labels.Country, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'recordType', label: Labels.RecordType, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'typeText', label: Labels.Topic, editable: false, cell: 'string', columnWidth: 'XL' },
        { name: 'subTypeText', label: Labels.Subtopic1, editable: false, cell: 'string', columnWidth: 'XL' },
        { name: 'subjectText', label: Labels.Subject, editable: false, cell: 'string', columnWidth: 'XL' }];
};

var configureTopics = function (options) {
    var subjects = options.subjects;
    var subtypes = options.subtypes;
    var types = options.types;
    var collection = new Entities.Classifications();
    var criteria = [];
    var regexCriterias = [];
    var aggregate = [];
    options.countries.each(function (country) {
        var recordTypes = new Entities.Enumerations(_.filter(Resources.Enumeration, { type: 'RecordType' }));
        recordTypes.each(function (recordType) {
            var criterion = {};
            var data = '/' + _.last(country.get("id").slice(1, -1).split('/')) + '/' + recordType.id.replace('_', "") + '/';
            criterion["_id"] = { $regex: data, $options: 'i' };
            regexCriterias.push(criterion);
        });
    });
    if (regexCriterias.length) {
        criteria.push({ $or: regexCriterias });
    }
    if (criteria.length) {
        aggregate.push({ $match: { $and: criteria } });
    }
    $('html,body').addClass('wait-cursor');
    return collection.fetch({
       aggregate: aggregate
    }).done(function () {
        var classificationByType = collection.groupBy('type');

        types.reset(classificationByType.Type);
        subtypes.reset(classificationByType.Subtype);
        subjects.reset(classificationByType.Subject);
    }).fail(function () {
        $('html,body').removeClass('wait-cursor');
    });
};

var Confirmation = Marionette.View.extend({
    template: '#exportConfirmation'
});


var configure = function (options) {
    var countries = new Entities.Geographies(Resources.CountriesFiltered.filter(function (item) {
        return User.roles && User.roles.length > 0 && new RegExp(User.adminGeography).test(item.id);
    }));
    //var recordTypes = new Entities.Enumerations(_.filter(Resources.Enumeration, { type: 'RecordType' }));

    options.subjects = new Entities.Classifications();
    options.subtypes = new Entities.Classifications();
    options.types = new Entities.Classifications();
    options.countryId = "";
    options.recordTypeId = "";
    var handleFileDownload = EY.Consultation.Lookups.Configuration.EnableXlsxDownload ? $.Deferred().resolve() : Dialog.show({
        saveLabel: Labels.OK,
        headerLabel: Labels.DialogTitleInformational,
        view: new Confirmation({
            model: new Backbone.Model({ message: Labels.MSG035 })
        })
    });
    
    handleFileDownload.done(function () {
        configureTopics(_.extend(options, { countries: countries })).done(function () {

        var types = options.types.map(function (type) {
            return {
                typeId: type.id,
                typeText: type.get("text")
            };
        });
        var subjects = options.subjects.map(function (subject) {
            var country = countries.findWhere(function (item) {
                return item.id.split("/")[3] === subject.get("id").split("/")[1];
            });
            return {
                text: subject.get("text"),
                parentSubjectId: subject.get("parentId"),
                subjectId: subject.id,
                subjectText: subject.get("text"),
                area: Geographies[country.id.replace(/[^\/]*\/[^\/]*\/$/, '')].text,
                region: Geographies[country.id.replace(/[^\/]*\/$/, '')].text,
                countryText: Geographies[country.id].text,
                recordType: Labels[RecordType[subject.get("id").split("/")[2].replace('RecordType', '')]]
            };
        });
        var subtypes = options.subtypes.map(function (subtype) {
            return {
                text: subtype.get("text"),
                parentSubtypeId: subtype.get("parentId"),
                subtypeId: subtype.id,
                subTypeText: subtype.get("text")
            };
        }); //let result = options.types.toJSON().map(x => Object.assign(x, subtypes.find(y => y.subtypeId.indexOf(x.id) === 0)));

        var resultSubtypes = subjects.map(function (x) {
            return _.extend(x, _.find(subtypes, function (y) {
                return y.subtypeId === x.parentSubjectId;
            }));
        });
        var result = resultSubtypes.map(function (x) {
            return _.extend(x, _.find(types, function (y) {
                return y.typeId === x.parentSubtypeId;
            }));
        });
        var searchedTopics = new searchTopicCollection(result);
        //options.searchedTopics.reset(result);
        ExportNode.send({ collection: searchedTopics, fields: fields(), columns: columns(), fileName: Labels.ExportTopicsFileName });
        $('html,body').removeClass('wait-cursor');
        //_.each(options.types.where(function (item) {
        //    return countries.any(function (c) {
        //        return c.id.indexOf(item.get("id").split("/")[1]) > 0;
        //    });
        //}), function (type) {
        //    //var countryId = type.get("id").split("/")[1];
        //    var country = countries.findWhere(function (country) {
        //        return country.id.indexOf(type.get("id").split("/")[1]) > 0;
        //    });

        //        var recordTypeId = RecordType[type.get("id").split("/")[2].replace('RecordType', '')];
        //    var area = Geographies[country.id.replace(/[^\/]*\/[^\/]*\/$/, '')].text;
        //    var region = Geographies[country.id.replace(/[^\/]*\/$/, '')].text;
        //    var countryText = Geographies[country.id].text;
        //    var recordType = Labels[recordTypeId];
        //    var filteredSubtypes = options.subtypes.filter(function (subtype) {
        //        return subtype.id.indexOf(type.id) === 0;
        //    });
        //    _.each(filteredSubtypes, function (filteredSubType) {

        //        var filteredSubjects = options.subjects.filter(function (subject) {
        //            return subject.id.indexOf(filteredSubType.id) === 0;
        //        });
        //        _.each(filteredSubjects, function (filteredSubject) {

        //            options.searchedTopics.add({
        //                area: area,
        //                region: region,
        //                country: countryText,
        //                recordType: recordType,
        //                typeText: type.get("text"),
        //                subTypeText: filteredSubType.get("text"),
        //                subjectId: filteredSubject.get("id"),
        //                subjectText: filteredSubject.get("text")
        //            });
        //        });

        //    });
        //    });


        //let result = options.types.toJSON().map(obj => {
        //    let data = options.subtypes.toJSON().find(item => item.id.indexOf(obj.id) === 0);
        //    return { ...obj, ...data };
        //});
        });

    });
};

module.exports.run = function (options) {
    configure(options);
};


// WEBPACK FOOTER //
// ./js/Modules/Classification/ExportTopics.js